import React from 'react';
import { Tag } from 'antd';

const StatusTag = ({ status, statuses = {} }) => {
    const statusConfig = statuses[status];

    if (!statusConfig) {
        return <Tag color="default">{status}</Tag>;
    }

    const { title, color } = statusConfig;

    const getLightColor = (hexColor) => {
        const hex = hexColor.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        const lightR = Math.round((r + 255 * 4) / 5);
        const lightG = Math.round((g + 255 * 4) / 5);
        const lightB = Math.round((b + 255 * 4) / 5);

        return `rgb(${lightR}, ${lightG}, ${lightB})`;
    };

    const lightColor = getLightColor(color);

    return (
        <Tag
            style={{
                backgroundColor: lightColor,
                borderColor: color,
                color: color,
                borderWidth: '1px',
                borderStyle: 'solid',
                fontWeight: '500'
            }}
        >
            {title}
        </Tag>
    );
};

export default StatusTag;
